"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.RefreshTokenSSR = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
const events = require('events');
const REFRESH_TOKEN_CHANGED = 'refresh_token_changed';
let RefreshTokenSSR = /*#__PURE__*/function () {
  function RefreshTokenSSR() {
    (0, _classCallCheck2.default)(this, RefreshTokenSSR);
    this._getting_refresh_token = false;
    this.eventEmitter = new events.EventEmitter();
  }
  (0, _createClass2.default)(RefreshTokenSSR, [{
    key: "isGettingRefreshToken",
    get: function () {
      return this._getting_refresh_token;
    }
  }, {
    key: "startGettingRefreshToken",
    value: function startGettingRefreshToken() {
      console.log('startGettingRefreshToken');
      this._getting_refresh_token = true;
      this.eventEmitter.emit('refresh_token_changed', {
        finishedGettingRefreshToken: !this._getting_refresh_token
      });
    }
  }, {
    key: "endGettingRefreshToken",
    value: function endGettingRefreshToken() {
      console.log('endGettingRefreshToken');
      this._getting_refresh_token = false;
      this.eventEmitter.emit('refresh_token_changed', {
        finishedGettingRefreshToken: !this._getting_refresh_token
      });
    }
  }, {
    key: "waitForRefreshToken",
    value: function waitForRefreshToken() {
      return new Promise(resolve => {
        this.eventEmitter.once(REFRESH_TOKEN_CHANGED, e => {
          console.log('got refresh token event listener');
          if (e.finishedGettingRefreshToken) {
            resolve();
          }
        });
      });
    }
  }]);
  return RefreshTokenSSR;
}();
exports.RefreshTokenSSR = RefreshTokenSSR;